import { Box, Grid, Typography, useTheme } from '@mui/material'
import { ShowWithAlphabetItems, nameItems, paidByItems, rowsPerPageItems } from './payrollConstants';
import { formatAmountCommaSeperator, formatDateToShow } from '../../../common/Common';

import { EnhancedDropDownRHF } from '@websential/cosmic-v20'
import { Link } from 'react-router-dom';
import { ProcessPayrollDropDown } from '../../ProcessPayrollDropDown';
import { ProcessPayrollDropDownRHF } from '../../ProcessPayrollDropDown/ProcessPayrollDropDownRHF';
import React from 'react'

interface IPayrollTimeSheetHeaderPanel {
    payFrequencyDDLItems: { label: string, value: string }[];
    onFrequencyChangeHandler: (selected: any) => void
    payrollPeriodsDDL: { label: string, value: string }[];
    onPayrollPeriodsDDLChangeHandler: (selected: any) => void
    employeesDDL: { label: string, value: string }[];
    onEmployeeSelectionChangeHandler: (selected: any) => void
    summary: any;
    payrollTimeSheetData: any;
    onWorkFormatSelectionChangeHandler: (e: any) => void;
    selectedEmployee: any
    onInputHoursChangeHandler: (e: any) => void;
    savedData: any
    timeFormat: any
    selectedPayPeriod: any
}
export const PayrollTimeSheetHeaderPanel: React.FC<IPayrollTimeSheetHeaderPanel> = ({
    payFrequencyDDLItems,
    onFrequencyChangeHandler,
    payrollPeriodsDDL,
    onPayrollPeriodsDDLChangeHandler,
    employeesDDL,
    onEmployeeSelectionChangeHandler,
    summary,
    payrollTimeSheetData,
    onWorkFormatSelectionChangeHandler,
    selectedEmployee,
    onInputHoursChangeHandler,
    savedData,
    timeFormat,
    selectedPayPeriod
}) => {
    const theme = useTheme();
    return (
        <>
            <Grid
                container
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                sx={{
                    background: "#fff",
                    border: "1px solid #e5e7eb",
                    borderBottom: 0,
                    borderRadius: "2px 2px 0 0",
                    padding: "31px 20px 1rem 20px"
                }}
                columnSpacing={2}
            >
                <Grid
                    size={{ xs: 12, sm: 4, md: 2, lg: 2, xl: 2 }}
                    sx={{ mt: "12px", "& .dropDownWrapper .dropDownField__menu": { zIndex: "999!important" } }}
                >
                    <EnhancedDropDownRHF
                        selectName="payFrequencyDDLItems"
                        testId={`payFrequencyDDLItems-list`}
                        items={payFrequencyDDLItems ?? []}
                        onSelectionChangeHandler={onFrequencyChangeHandler}
                    />
                    {/* <EnhancedDropDownRHF
                            selectName="payrollPeriodsDDL"
                            testId={`payrollPeriodsDDL`}
                            items={payrollPeriodsDDL ?? []}
                            onSelectionChangeHandler={onPayrollPeriodsDDLChangeHandler}
                        /> */}
                    <ProcessPayrollDropDownRHF
                        selectName="payrollPeriodsDDL"
                        testId={`payrollPeriodsDDL`}
                        items={payrollPeriodsDDL ?? []}
                        onSelectionChangeHandler={onPayrollPeriodsDDLChangeHandler}
                    />
                    <EnhancedDropDownRHF
                        selectName="employee"
                        testId={`employee-list`}
                        items={employeesDDL ?? []}
                        onSelectionChangeHandler={onEmployeeSelectionChangeHandler}
                        showEmpty
                    />
                    {selectedEmployee && <EnhancedDropDownRHF
                        selectName="workFormat"
                        testId={`workFormat-list`}
                        items={[{ label: "Hours Worked", value: 100 }, { label: "Time In and Time Out", value: 200 }]}
                        onSelectionChangeHandler={onWorkFormatSelectionChangeHandler}
                        selectedItem={100}
                        isDisabled={savedData ? true : false}
                    />}
                    {timeFormat === 100 ?
                        <>
                            <Typography style={{ color: "rgb(88 83 83 / 58%)", fontSize: "0.675rem", padding: 0 }}>Time format is Fraction(0-99) 1.50 = 1 hr 30 min</Typography>
                            <Typography style={{ color: "rgb(88 83 83 / 58%)", fontSize: "0.675rem" }}>Save hours before switching employee.</Typography>
                        </> :
                        <>
                            <Typography style={{ color: "rgb(88 83 83 / 58%)", fontSize: "0.675rem", padding: 0 }}>Time format is Minutes(0-59) 1.30 = 1 hr 30 min</Typography>
                            <Typography style={{ color: "rgb(88 83 83 / 58%)", fontSize: "0.675rem" }}>Save hours before switching employee.</Typography>
                        </>}
                </Grid>
                <Grid size={{ xs: 12, sm: 3, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
                {/* {summary && <><Grid
                    size={{ xs: 12, sm: 3, md: 1, lg: 1, xl: 1 }}
                    sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem" }}
                >
                    Employees {summary && summary.totalEmployees}
                    <br /> Paid {summary && summary.paidEmployees}
                    <br />
                    Inactive {summary && summary.inactiveEmployees}
                </Grid>
                    <Grid
                        size={{ xs: 12, sm: 3, md: 2, lg: 2, xl: 2 }}
                        sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem" }}
                    >
                        Paid By Cheque {summary && summary.paidByCheque}
                        <br /> Paid By Direct Deposit {summary && summary.paidByDirectDeposit}
                        <br />
                        Cheque Amount ${formatAmountCommaSeperator(summary && summary.chequeAmount)}
                        <br />
                        Direct Deposit Amount ${formatAmountCommaSeperator(summary && summary.directDepositAmount)}
                    </Grid>
                    <Grid
                        size={{ xs: 12, sm: 3, md: 1.5, lg: 1.5, xl: 1.5 }}
                        sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem" }}
                    >
                        <span style={{ height: "10px", width: "10px", background: "#E5FFE8" }}>&nbsp;&nbsp;&nbsp;</span>&nbsp;
                        <span>Earning</span>
                        <br />
                        <span style={{ height: "10px", width: "10px", background: "#FFF2F2" }}>&nbsp;&nbsp;&nbsp;</span>&nbsp;
                        <span>Deduction</span>
                        <br />
                        <span style={{ height: "10px", width: "10px", background: "#F6E5FF" }}>&nbsp;&nbsp;&nbsp;</span>&nbsp;
                        <span>Reimbursement</span>

                    </Grid></>}
                <Grid
                    size={{ xs: 12, sm: 3, md: 2, lg: 2, xl: 2 }}
                    sx={{
                        textAlign: "right",
                        color: "rgba(0, 0, 0, 0.6)",
                        fontSize: "0.875rem",
                        marginLeft: "auto"
                    }}
                >
                    <Link
                        to={`/reports/payroll`}
                        className="no-underline"
                        style={{ color: theme.palette.primary.light }}
                    >
                        Payroll Report
                    </Link>
                    <br />
                    <Link
                        to={`/reports/timesheet`}
                        className="no-underline"
                        style={{ color: theme.palette.primary.light }}
                    >
                        Time Sheet Report
                    </Link>
                    <br />
                    <Link
                        to={`#`}
                        className="no-underline"
                        style={{ color: theme.palette.primary.light }}
                    // onClick={onClickImportPayrollDataHandler}
                    >
                        Import Payroll Data
                    </Link>
                    <br />
                    Statutory Holiday Eligibility <br />
                    <Link
                        to={`/settings/general/setup`}
                        className="no-underline"
                        style={{ color: theme.palette.primary.light }}
                    >
                        Time format
                    </Link> 1.30 = 1 hr 30 mins.
                </Grid> */}
            </Grid>
            {payrollTimeSheetData && payrollTimeSheetData.items && payrollTimeSheetData.items.length > 0 && <Grid
                container
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                sx={{
                    background: "#fff",
                    border: "1px solid #e5e7eb",
                    borderBottom: 0,
                    borderRadius: "2px 2px 0 0",
                    padding: "31px 5px 0 5px",
                    "& .dropDownWrapper": { marginBottom: "0!important" },
                    "& .dropDownWrapper .dropDownField__menu": { zIndex: "999!important" }
                }}
                columnSpacing={2}
            >
                <Grid
                    size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }}>

                    {selectedEmployee && <EnhancedDropDownRHF
                        selectName="inputHours"
                        testId={`inputHours`}
                        items={[{ label: "Input Regular Hrs", value: 100 }, { label: "Input Overtime 1.5", value: 200 }, { label: "Input Overtime 2.0", value: 300 }]}
                        selectedItem={100}
                        onSelectionChangeHandler={onInputHoursChangeHandler}
                    />}
                </Grid>
            </Grid>}

        </>
    )
}

